<p>collapse-panel works!</p>
